import React from 'react';
import { Link } from 'react-router-dom'

import Check from '../../assets/check.svg'
import DropUE from '../../assets/categories/DropUE.png'
import Arrow from '../../assets/arrow.svg'
import GreyArrow from '../../assets/grey arrow.svg'

import Redo from '../App/Redo';
import Banner from '../App/Banner';

function DropShippingUE() {
  return(
    <div>
      <Banner />
      <div className='paper'>

        <Link to='/Hors-UE'>
            <button className="return">
            <img src={GreyArrow} alt="fleche grise"/>
              Retour
            </button>
        </Link>

        <div className="breadcrumbs">
          <p><img src={Check} />Votre stock se situe hors Union Européenne</p>
          <p><img src={Check} />La valeur de la marchandise est supérieuse à 150 €</p>
        </div>
        
        <h4>La procédure :</h4>
        <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Appliquez le taux de TVA du pays de destination</ul>      
        <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Faites la demande d’immatriculation à la TVA du pays de destination</ul>     
        <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Payez la TVA au moment de l’importation, sur la déclaration nationale du pays de destination</ul>
        <hr />

        <div className='categorie' >
          <h4>Si vous êtes client Dougs…</h4>
          <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Sélectionnez la catégorie ci-dessous</ul>
          <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Sélectionnez le pays de destination</ul>
          <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />La TVA se calcule automatiquement</ul>
          <img src={DropUE} alt="Categorie dropshipping UE" />
        </div>

        <div className="button">
          <Redo />
        </div>
      </div>
    </div>

  )
}

export default DropShippingUE